import { QuestionWithRelations } from "../../../../api/src/types";
import Checkbox from "./questionnaireInputs/Checkbox";
import Radio from "./questionnaireInputs/Radio";
import Dropdown from "./questionnaireInputs/Dropdown";
import TextAreaInput from "./questionnaireInputs/TextArea";
import TextFieldInput from "./questionnaireInputs/TextField";
import CurrencyField from "./questionnaireInputs/CurrencyField";
import NumberField from "./questionnaireInputs/NumberField";
import DateField from "./questionnaireInputs/DateField";
import PhoneInputField from "./questionnaireInputs/PhoneField";
import ReadOnlyQuestion from "./utils/ReadOnlyQuestion";

interface QuestionRendererProps {
  question: QuestionWithRelations;
  documentId: string;
  isReadOnly?: boolean;
}

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  documentId,
  isReadOnly = false,
}) => {
  // Feature for attorneys
  if (isReadOnly) {
    return <ReadOnlyQuestion question={question} />;
  }
  // Render input based on question type
  switch (question.questionType) {
    case "CHECKBOX":
      return <Checkbox question={question} documentId={documentId} />;

    case "RADIO":
      return <Radio question={question} documentId={documentId} />;

    case "DROPDOWN":
      return <Dropdown question={question} documentId={documentId} />;

    case "TEXT_AREA":
      return <TextAreaInput question={question} documentId={documentId} />;

    case "TEXT_BOX":
      // For TEXT_BOX, further check the inputType
      switch (question.inputType) {
        case "CURRENCY":
          return <CurrencyField question={question} documentId={documentId} />;
        case "NUMBER":
          return <NumberField question={question} documentId={documentId} />;
        case "DATE":
          return <DateField question={question} documentId={documentId} />;
        case "PHONE":
          return (
            <PhoneInputField question={question} documentId={documentId} />
          );
        default:
          return <TextFieldInput question={question} documentId={documentId} />;
      }
    default:
      // Default to text field input for any unknown question type
      return <TextFieldInput question={question} documentId={documentId} />;
  }
};

export default QuestionRenderer;
